import { render, staticRenderFns } from "./cabinet-commercial-proposals-list.vue?vue&type=template&id=0b9544ba&"
import script from "./cabinet-commercial-proposals-list.vue?vue&type=script&lang=js&"
export * from "./cabinet-commercial-proposals-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b9544ba')) {
      api.createRecord('0b9544ba', component.options)
    } else {
      api.reload('0b9544ba', component.options)
    }
    module.hot.accept("./cabinet-commercial-proposals-list.vue?vue&type=template&id=0b9544ba&", function () {
      api.rerender('0b9544ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/commercial/cabinet-commercial-proposals-list.vue"
export default component.exports